<template>
  <v-row no-gutters>
    <v-col v-for="step in 5" :key="step" class="px-1">
      <v-sheet
        height="6"
        rounded
        :color="segmentColor(step)"
      ></v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import zxcvbn from "zxcvbn"

// One color per zxcvbn score (0-4), weakest to strongest.
const stepColors = [
  "red-darken-4",
  "red",
  "yellow-darken-2",
  "green",
  "green-darken-4"
]

export default {
  props: {
    password: {
      type: String,
      default: ""
    }
  },
  computed: {
    // zxcvbn rates password strength from 0 (weak) to 4 (strong).
    score() {
      return zxcvbn(this.password).score
    },
    // How many of the 5 segments to light up: one per score point
    // reached, but none at all while the password field is empty.
    numberOfFilledSegments() {
      if (!this.password) {
        return 0
      }
      return this.score + 1
    },
    // Every filled segment shows the color for the current score.
    color() {
      return stepColors[this.score]
    }
  },
  methods: {
    segmentColor(step) {
      // step is this segment's 1-5 position, left to right; it's
      // filled if that position falls within the count we should fill.
      const isFilled = step <= this.numberOfFilledSegments
      if (!isFilled) {
        return "grey-lighten-2"
      }
      return this.color
    }
  }
}
</script>
